/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { useEffect, useState } from 'react';
import bannerPromoHelper from './bannerPromoHelper';

const getCurrentPromoCode = () => bannerPromoHelper.getBannerPromoCode(
    bannerPromoHelper.getBannerCookie(),
);

const useBannerPromoCode = () => {
    const [promoCode, setPromoCode] = useState(getCurrentPromoCode);

    useEffect(() => {
        const unsubscribe = bannerPromoHelper.subscribeToBannerCookie((bannerCookie) => {
            setPromoCode(bannerPromoHelper.getBannerPromoCode(bannerCookie));
        });

        // Catch an update that happened between the initial render and subscription.
        setPromoCode(getCurrentPromoCode());
        return unsubscribe;
    }, []);

    return promoCode;
};

export default useBannerPromoCode;
